<template>
  <Button v-bind="buttonAttrs" :variant="buttonVariant" :class="buttonClass" @click="onClick">
    <slot />
  </Button>
</template>

<script setup lang="ts">
import type { NodeProps } from './RenderNode.vue';
import { computed } from 'vue';
import { downloadFile } from '@/lib/download';
import { getButtonAttrs } from '../extensions/Button/ButtonExtension';
import Button from '@ui/button/Button.vue';

const props = defineProps<NodeProps>();
const attrs = computed(() => getButtonAttrs(props.node.attrs));
const isDownload = computed(() => attrs.value.type === 'download');
const buttonAttrs = computed(() =>
  isDownload.value
    ? { as: 'button' }
    : { as: 'a', href: attrs.value.href, target: '_blank', rel: 'noopener' },
);
const buttonVariant = computed(() =>
  attrs.value.preset === 'secondary' ? 'outline-post-secondary' : 'default',
);
const buttonClass = computed(() => (attrs.value.preset === 'secondary' ? 'btn--outline' : ''));

function onClick() {
  if (isDownload.value && attrs.value.href) {
    downloadFile(attrs.value.href);
    props.addTelemetry?.('download');
  }
}
</script>
